import classes from './Bar.module.sass'
import { IconButton } from '../iconButton/IconButton'
import login from '../../../../src/assets/images/icons/login.svg'
import logout from '../../../../src/assets/images/icons/logout.svg'
import arrow_back from '../../../../src/assets/images/icons/arrow_back.svg'
import home from '../../../../src/assets/images/icons/home.svg'
import profile from '../../../../src/assets/images/icons/profile.svg'
import settings from '../../../../src/assets/images/icons/settings.svg'

import { useBar } from './hooks/useBar'
import { useLogout } from '../../hooks/useLogout'
import { useLocation, useNavigate } from 'react-router-dom'
import { chatAdminId, MAIN_ROUTE, SETTINGS_ROUTE, USER_ROUTE } from '../../utils/constants'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import { selectConnected } from '../../../store/slices/wsSlice'

const ANCHORS = [
  { id: 'features', label: 'ВОЗМОЖНОСТИ', short: 'ФУНКЦИИ', mobile: true },
  { id: 'integrations', label: 'ИНТЕГРАЦИИ', short: 'ИНТЕГР.', mobile: false },
  { id: 'cases', label: 'РЕЗУЛЬТАТЫ', short: 'РЕЗУЛЬТАТ', mobile: true },
  { id: 'projects', label: 'ПРОЕКТЫ', short: 'ПРОЕКТЫ', mobile: true },
  { id: 'pricing', label: 'СТОИМОСТЬ', short: 'ЦЕНЫ', mobile: true },
  { id: 'request', label: 'ЗАЯВКА', short: 'ЗАЯВКА', mobile: true },
]

export const Bar = () => {
  const currentUser = useSelector(selectCurrentUser)
  const { setLoginModalState, toggleMapSliderAction, connectedList } = useBar()
  const isConnected = useSelector(selectConnected)
  const { logOut } = useLogout()
  const navigate = useNavigate()
  const location = useLocation()

  const showAnchors = !currentUser && location.pathname === MAIN_ROUTE

  const scrollTo = (id: string) => {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <div className={classes.Container}>
      <div className={classes.LeftSideContainer}>
        <IconButton
          icon={arrow_back}
          display={
            location.pathname !== MAIN_ROUTE && !location.pathname.split('/').includes('form')
          }
          alt={'Назад'}
          onClick={() => {
            navigate(-1)
          }}
        />
        <IconButton
          icon={home}
          display={location.pathname !== MAIN_ROUTE}
          alt={'На главную'}
          onClick={() => navigate(MAIN_ROUTE)}
        />
        <IconButton
          icon={profile}
          display={Boolean(location.pathname !== USER_ROUTE && currentUser?.id)}
          alt={'Кабинет'}
          onClick={() => navigate(USER_ROUTE)}
        />
      </div>

      {showAnchors && (
        <>
          <nav className={classes.AnchorsDesktop}>
            {ANCHORS.map((a) => (
              <button
                key={a.id}
                className={classes.Anchor}
                onClick={() => scrollTo(a.id)}
                type="button"
              >
                {a.label}
              </button>
            ))}
          </nav>

          <nav className={classes.AnchorsMobile}>
            {ANCHORS.filter((a) => a.mobile).map((a) => (
              <button
                key={a.id}
                className={classes.Anchor}
                onClick={() => scrollTo(a.id)}
                type="button"
              >
                {a.short}
              </button>
            ))}
          </nav>
        </>
      )}

      <div className={classes.RightSideContainer}>
        {currentUser && currentUser.id === chatAdminId && (
          <div className={classes.ConnectedCounter}>
            <div className={classes.ConnectedNumber}>
              {isConnected
                ? `${connectedList.filter((el) => el.userId && el.userId !== chatAdminId).length}|${
                    connectedList.filter((el) => el.userId !== chatAdminId).length
                  }`
                : '0|0'}
            </div>
          </div>
        )}

        <IconButton
          icon={settings}
          display={Boolean(currentUser) && location.pathname !== SETTINGS_ROUTE}
          alt={'Настройки'}
          onClick={() => navigate(SETTINGS_ROUTE)}
        />
        {process.env.REACT_APP_COUNTRY === 'ru' && (
          <IconButton
            icon={!currentUser ? login : logout}
            display
            alt={!currentUser ? 'Войти' : 'Выйти'}
            onClick={() => {
              !currentUser ? setLoginModalState(true) : logOut()
            }}
          />
        )}
      </div>
    </div>
  )
}